import { render } from "./feedSkeletonLoader.vue?vue&type=template&id=312003f5&scoped=true"
import script from "./feedSkeletonLoader.vue?vue&type=script&lang=js"
export * from "./feedSkeletonLoader.vue?vue&type=script&lang=js"

import "./feedSkeletonLoader.vue?vue&type=style&index=0&id=312003f5&scoped=true&lang=scss"

import exportComponent from "D:\\wemet-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-312003f5"]])

export default __exports__